import { Spacer, TextLoader } from '@procurify/ui'

import { StatusCardLegacy } from './StatusCardLegacy'

export interface IStatusCardLegacyLoaderProps {
  hasCheckbox?: boolean
  hasMenuButton?: boolean
}

export const StatusCardLegacyLoader = ({
  hasCheckbox = false,
  hasMenuButton = false,
}: IStatusCardLegacyLoaderProps) => {
  return (
    <StatusCardLegacy>
      {hasCheckbox && (
        <StatusCardLegacy.Left>
          <TextLoader height={14} width={14} />
        </StatusCardLegacy.Left>
      )}

      <StatusCardLegacy.Content>
        <StatusCardLegacy.Content.Left>
          <TextLoader height={38} width={120} />

          <Spacer />

          <TextLoader width={80} />
        </StatusCardLegacy.Content.Left>

        <StatusCardLegacy.Content.Right>
          <StatusCardLegacy.Content.Table
            headerLeft={{
              label: null,
              value: <TextLoader height={18} width={200} />,
            }}
            dataLeft={[
              {
                label: <TextLoader width={80} />,
                value: <TextLoader width={120} />,
              },
              {
                label: <TextLoader width={80} />,
                value: <TextLoader width={120} />,
              },
              {
                label: <TextLoader width={80} />,
                value: <TextLoader width={120} />,
              },
              {
                label: <TextLoader width={80} />,
                value: <TextLoader width={120} />,
              },
            ]}
            dataRight={[
              {
                label: <TextLoader width={80} />,
                value: <TextLoader width={120} />,
              },
            ]}
          />
        </StatusCardLegacy.Content.Right>
      </StatusCardLegacy.Content>

      {hasMenuButton && (
        <StatusCardLegacy.Right>
          <TextLoader width={38} height={38} />
        </StatusCardLegacy.Right>
      )}
    </StatusCardLegacy>
  )
}
StatusCardLegacyLoader.displayName = 'StatusCardLegacyLoader'
